/**
 * Where someone goes to join the gym or sign in as a guest.
 *
 * Both pages live in the member app, so a link handed out from here has to
 * point at the right one: a staging gym does not exist in production.
 *
 * Mirrors `memberAppUrl` in apps/web: derived from VITE_APP_ENV, which the
 * deploy workflow already sets per branch, so no new secret is needed.
 * VITE_MEMBER_APP_URL overrides it for local work.
 */
const HOSTS = {
  production: 'https://app.structuralclimbing.com',
  staging: 'https://staging.structural-app.pages.dev',
} as const

export function memberAppUrl(path = ''): string {
  const override = import.meta.env.VITE_MEMBER_APP_URL as string | undefined
  const env = import.meta.env.VITE_APP_ENV as string | undefined
  const base = override || (env === 'production' ? HOSTS.production : HOSTS.staging)
  return `${base.replace(/\/$/, '')}${path}`
}
